import React, { Fragment, useState } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
  Table,
} from "reactstrap";
import classnames from "classnames";
import moment from "moment";

const ListLeaveTypeItem = React.memo((props) => {
  const { selectedItem, assetList } = props;
  const [activeTab, setActiveTab] = useState("1");
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  return (
    <Fragment>
    
      <Container className="mt-2">
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <Row>
              <Col lg={12} md={3} sm={6} xs={12} className="mb-3 ">
                <Table striped>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Leave Type</th>
                      <th>Request Type</th>
                      <th>Employee Type</th>
                      <th>NoOf Leaves Per Year</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      // props.assetData

                      assetList
                        .filter((el) => el.leaveTypeMasterId  === selectedItem.id)
                        .map((itemData, i) => {
                          return (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{itemData.type}</td>
                              <td>{itemData.requestType}</td>
                              <td>{itemData.employeeTypeValue == null ? "All" :itemData.employeeTypeValue}</td>                        
                              <td>{itemData.noOfLeavesAppliedPerYear}</td>
                              <td>
                              <i
                                  className="fas fa-edit"
                                  onClick={() => {
                                    props.handleEditLeaveTypeItem(itemData, i);
                                    // props.toggle();
                                  }}
                                ></i>
                                 &nbsp;
                                <i
                                  className="fas fa-trash"
                                  onClick={() =>
                                    props.handleDelLeaveTypeList(itemData)
                                  }
                                ></i>
                               
                               
                              </td>
                            </tr>
                          );
                        })
                    }
                  </tbody>
                </Table>
              </Col>
            </Row>
          </TabPane>
         
        </TabContent>
      </Container>
    </Fragment>
  );
});

export default ListLeaveTypeItem;
